import React from "react";
import IconBeBold from "../../icons/icon-be-bold.svg";
import IconStayHungry from "../../icons/icon-stay-hungry.svg";
import IconSeekExcellence from "../../icons/icon-seek-excellence.svg";
import IconMoveFast from "../../icons/icon-move-fast.svg";
import IconFocusImpact from "../../icons/icon-focus-impact.svg";
import IconEmbraceHumanity from "../../icons/icon-embrace-humanity.svg";
import BannerCareer from "../../images/banner-career-page.jpg";

export const mainBannerObj = {
  classes: "career-banner",
  header: (<>Build a meaningful career</>),
  position: "left",
  content: (<><p>Are you hungry to impact the world with your work?</p></>),
  buttonText: "View current openings",
  link: "openings",
  scrollSection: "career-services",
  mediaType: "",
  mediaSource: "",
  mediaClass: "",
  mediaPoster: BannerCareer,
  bottomGap: "",
  imageSource: BannerCareer
};

export const CareerServicesObj = {
  title: "OUR CULTURE",
  header: "Enable every business to positively impact the way people live, work, and enjoy their lives.",
  content: (<><p>These are the core values we live by. They guide everything - what we do, why we do it, and how we build, partner and hire.</p></>),
  gridItems: [
    {
      icon: <IconBeBold />,
      header: "Be Bold",
      content: "Dream big, take risks, and speak your mind"
    },
    {
      icon: <IconMoveFast />,
      header: "Move Fast",
      content: "Build quickly, fail fast, and learn faster - time is precious"
    },
    {
      icon: <IconFocusImpact />,
      header: "Focus on Impact",
      content: "Deliver ‘real’ value and exceed expectations, always"
    },
    {
      icon: <IconStayHungry />,
      header: "Stay Hungry",
      content: "Stay curious, learn new skills, and keep growing"
    },
    {
      icon: <IconSeekExcellence />,
      header: "Seek Excellence",
      content: "Master the innovation, quality, and craftsmanship"
    },
    {
      icon: <IconEmbraceHumanity />,
      header: "Embrace Humanity",
      content: "Be caring, open-minded, and encouraging to everyone"
    },

  ],
};

export const CareerPerksObj = {
  title: "OUTSTANDING PERKS",
  header: "Live your best work-life",
  content: (<><p>Along with the unlimited growth opportunities, we offer outstanding benefits (and a lot of fun) for you to be
  happy, healthy, and successful in your work and personal life.</p></>),
  listItems: [
    {
      content: "Competitive Salary"
    },
    {
      content: "Training & Development"
    },
    {
      content: "Parental leave & support"
    },
    {
      content: "Annual Trips"
    },
    {
      content: "Paid Sabbatical"
    },
    {
      content: "Celebrations & Events"
    },
    {
      content: "Referral Bonuses"
    },
    {
      content: "Continuous Learning"
    },
    {
      content: "Awards & Recognitions"
    },
    {
      content: "Outstanding Colleagues"
    },
    {
      content: "Sports Tournaments"
    },
    {
      content: "Health Insurance"
    },
    {
      content: "Flexible Environment"
    },
    {
      content: "Retirement & Pension Funds"
    },
  ],
};